import { render, staticRenderFns } from "./twelve.vue?vue&type=template&id=7897affb"
import script from "./twelve.vue?vue&type=script&lang=js"
export * from "./twelve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports